import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";

import { BasicResourceType } from "../../../../../../../../types/resources/resources.enums";
import { BorderedBlock } from "../../../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { ConfirmationModal } from "../../../../../../../../components/modals/confirmation-modal/confirmation-modal.component";
import { DateField } from "../../../../../../../../features/forms/fields/date-field/date-field.component";
import { Nullable } from "../../../../../../../../types/common";
import { ProductHistory } from "../../../../../../../../features/product-history/components/product-history.component";
import { RichTextField } from "../../../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { SelectField } from "../../../../../../../../features/forms/fields/select-field/select-field.component";
import { TextField } from "../../../../../../../../features/forms/fields/text-field/text-field.component";
import { UnsavedChangesModal } from "../../../../../../../../components/modals/UnsavedChangesModal/unsaved-changes-modal.component";
import { useControlForm } from "../../../../../../../../features/forms/forms.hook";

import { flyerDataFormats } from "../../../../../../types/flyer-detail-data/flyer-detail-data.constants";

import { flyerDetailFormValidation } from "../../../../types/flyer-detail-form/flyer-detail-form.validation";

import { FlyerDetailOverviewTabProps } from "./flyer-detail-overview-tab.props";

export const FlyerDetailOverviewTab = (props: FlyerDetailOverviewTabProps) => {
  const { formErrors } = props;

  const [paginationStatus, setPaginationStatus] = useState<Nullable<string>>(null);

  const form = useControlForm({
    defaultValues: props.values,
    formRef: props.formRef,
    validationRules: flyerDetailFormValidation,
  });

  useEffect(() => {
    formErrors?.fieldErrors?.forEach((field) =>
      form.setError(
        field.fieldName,
        { type: "custom", message: field.errorMessage },
        { shouldFocus: true }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formErrors]);

  const onChangePaginationStatus = (event: React.ChangeEvent<any>) => {
    setPaginationStatus(event.target.value);
  };

  const cancelChangePaginationStatus = () => setPaginationStatus(null);

  const confirmChangePaginationStatus = () => {
    form.setValue("paginationStatus", paginationStatus);
    cancelChangePaginationStatus();
  };

  return (
    <>
      <UnsavedChangesModal forceOpen={props.forceOpen} when={form.isDirty} />
      <ConfirmationModal
        title="Confirm Change Pagination Status"
        isOpen={Boolean(paginationStatus !== null)}
        onConfirm={confirmChangePaginationStatus}
        onCancel={cancelChangePaginationStatus}
      >
        Are you sure you want to change the flyer's pagination status?
      </ConfirmationModal>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ProductHistory
            buttonText="Product History"
            resourceId={props.flyerId}
            resourceType={BasicResourceType.Flyer}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <BorderedBlock>
            <TextField
              form={form}
              hidden
              label="id"
              name="id"
              userPermissions={props.permissions}
            />
            <RichTextField
              form={form}
              label="Overview"
              name="overview"
              required
              userPermissions={props.permissions}
            />
          </BorderedBlock>
          <BorderedBlock>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DateField
                  form={form}
                  label="Start date"
                  name="startAt"
                  required
                  userPermissions={props.permissions}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DateField
                  form={form}
                  label="End date"
                  name="endAt"
                  required
                  userPermissions={props.permissions}
                />
              </Grid>
            </Grid>
          </BorderedBlock>
        </Grid>
        <Grid item xs={12} md={4}>
          <BorderedBlock>
            <SelectField
              form={form}
              label="Pagination Status"
              name="paginationStatus"
              onChange={onChangePaginationStatus}
              userPermissions={props.permissions}
              options={[
                { label: "Active", value: "1" },
                { label: "InActive", value: "0" },
              ]}
            />
          </BorderedBlock>
          <BorderedBlock>
            <SelectField
              form={form}
              label="Format"
              name="format"
              options={flyerDataFormats}
              userPermissions={props.permissions}
            />
          </BorderedBlock>
          <BorderedBlock>
            <DateField
              form={form}
              label="First Review: Ad Planner Updates to be Completed"
              name="wtwReviewDate"
              required
              userPermissions={props.permissions}
            />
          </BorderedBlock>
          <BorderedBlock>
            <DateField
              form={form}
              label="Sr. Review: Ad Planner Updates to be Completed"
              name="wtwSeniorReviewDate"
              required
              userPermissions={props.permissions}
            />
          </BorderedBlock>
        </Grid>
      </Grid>
    </>
  );
};
